import type { JSX } from 'react'

export const SeacrhIcon = (): JSX.Element => (
  <use href='#searchIcon' height='100%' width='100%' />
)
